module.exports = __webpack_public_path__ + "img/image-user-x.dfc1f99b.svg";